// ============================================================
// api/clients.js
// Endpoint binding for mgmt/clients/list.
//
// Backend reference:
//   backend/func-carehub-api/src/functions/admin-clients-list.js
//   APIM operation: mgmt-clients-list
//
// Read-only. No mutation endpoints for Clients exist yet — when
// they land (Client Management module, post-Phase-3), they'll be
// added here as siblings.
// ============================================================

import { apiGet } from './client';

/**
 * List Clients with optional filters, search, and sort.
 *
 * All params are optional. Unknown params are silently ignored
 * by the backend. `limit` is silently clamped to [1, 200].
 *
 * @param {Object}  [params={}]
 * @param {('trial'|'active'|'disabled')}                                [params.lifecycleStatus]
 * @param {('care_home'|'domiciliary_agency'|'mixed')}                   [params.clientType]
 * @param {number}                                                       [params.tenantId]
 * @param {boolean}                                                      [params.includeInactive]
 * @param {string}                                                       [params.search]            Substring match against ClientName or DisplayName, max 200 chars.
 * @param {('name'|'createdAt'|'userCount')}                             [params.sortBy='createdAt']
 * @param {('asc'|'desc')}                                               [params.sortDir='desc']
 * @param {number}                                                       [params.limit=50]          1..200
 * @param {number}                                                       [params.offset=0]
 *
 * @returns {Promise<{
 *   clients: Array<{
 *     clientId: number,
 *     clientName: string,
 *     displayName: string|null,
 *     lifecycleStatus: 'trial'|'active'|'disabled',
 *     clientType: 'care_home'|'domiciliary_agency'|'mixed',
 *     tenantId: number|null,
 *     tenantName: string|null,
 *     isActive: boolean,
 *     createdAt: string|null,
 *     updatedAt: string|null,
 *     userCount: number,
 *     pendingInvitationCount: number,
 *   }>,
 *   pagination: { limit: number, offset: number, returned: number }
 * }>}
 */
export async function listClients(params = {}) {
  return apiGet('/mgmt/clients', params);
}
